module.exports = __webpack_public_path__ + "img/gi-laurel.33cbb8b6.png";